/* Klaviyo reviews — swap the star glyph for the Figma one (1092:2945).
   =====================================================================
   Klaviyo draws each star as an <svg viewBox="0 0 20 20"> containing a
   <defs><linearGradient> whose stops carry .kl_reviews__star--fill /
   --empty, and ONE <path fill="url(#thatGradient)">. The gradient is how a
   fractional rating renders: the 4.9 average puts a stop at 66% on the
   fifth star (class .kl_reviews__partial_star), so part of the glyph is
   gold and the rest grey.

   That is why this rewrites ONLY the path's `d` and the svg's `viewBox`,
   and never replaces the glyph wholesale. Swapping in a complete <svg> —
   or masking the element and painting a flat background — would discard
   the gradient, and every partial star would round UP to a full one: 4.9
   would silently render as 5.0. The fill reference is left untouched, so
   the vendor's own partial-fill machinery keeps working against the new
   shape.

   The viewBox is the Figma export's own 26x25. It is not square, but the
   default preserveAspectRatio letterboxes it inside the square CSS box the
   stylesheet sets, so the star centres rather than stretching.

   Klaviyo re-renders its widgets on filter/sort/tab changes and hydrates
   product-card badges lazily, so a one-shot pass would style only what
   existed at load. Hence the observer, and the data-flag so re-running over
   an already-swapped star is free. */
(function () {
  var STAR_D =
    'M13.0001 0L16.6157 8.69287L26.0004 9.44524L18.8503 15.5701L21.0347 24.728' +
    'L13.0001 19.8205L4.96554 24.728L7.15002 15.5701L-0.000117238 9.44524' +
    'L9.38457 8.69287L13.0001 0Z';
  var SEL = '.kl_reviews__full_star,.kl_reviews__partial_star,.kl_reviews__empty_star';

  function swap(scope) {
    var svgs = (scope && scope.querySelectorAll ? scope : document).querySelectorAll(SEL);
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (svg.getAttribute('data-sp-star')) continue;
      var path = svg.querySelector('path');
      if (!path) continue;
      svg.setAttribute('viewBox', '0 0 26 25');
      path.setAttribute('d', STAR_D);
      svg.setAttribute('data-sp-star', '1');
    }
  }

  function boot() {
    swap(document);
    if (!window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; swap(document); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
